import { Uuid } from "@/dto/CommonDto.ts";
import { Role } from "@/enum/RoleEnum.ts";
import { Nullable } from "@/type/Common.ts";

class User extends Uuid {
    readonly email: string;
    readonly name: string;
    readonly phone: Nullable;
    readonly roles: Role[];

    constructor(email: string, name: string, phone: Nullable, roles: Role[]) {
        super();
        this.email = email;
        this.name = name;
        this.phone = phone;
        this.roles = roles;
    }

    public hasRole(role: Role): boolean {
        return this.hasRoles([role]);
    }

    public hasRoles(roles: Role[]): boolean {
        return roles.some(role => this.roles.includes(role));
    }
}

export default User;